// form13FInvestors
import { useEffect, useState } from "react";
import axios from 'axios';
import { financialModelingPrepApiKey } from "data/keys";

export default function useTopInvestorsList() {
    const [topInvestors, setData] = useState([]);
    const [loading,setLoading] = useState(false)
    useEffect(() => {
      const fetchData = async () => {
        try {
          setLoading(true)
          const response = await axios.get(
            `
            https://financialmodelingprep.com/api/v4/institutional-ownership/list?apikey=${financialModelingPrepApiKey}            
            `
          );
          setData(response.data);
        } catch (error) {
          console.error(error);
        }
        finally{ 
        setLoading(false)
        }
      };
  
     fetchData();
    }, []);
  
    return { topInvestors };
  }